module.exports = __webpack_public_path__ + "img/header-engagementRingsSolitaire.c109e8e.webp";